module.exports = __webpack_public_path__ + "static/img/pic-right.0d51e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/join-us/assets/pic-right.png
// module id = d+ah
// module chunks = 1